module.exports = __webpack_public_path__ + "static/media/wanted.c4598936.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/wanted.svg
// module id = 188
// module chunks = 0